// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ne0N","rootMobile":"styles_rootMobile__3dF2_"};